export default __webpack_public_path__ + "static/media/Ceník služeb.3fa8affd.pdf";